import { render } from "./decline-popup.vue?vue&type=template&id=b2c88a4e&scoped=true&ts=true"
import script from "./decline-popup.vue?vue&type=script&lang=ts"
export * from "./decline-popup.vue?vue&type=script&lang=ts"

import "./decline-popup.vue?vue&type=style&index=0&id=b2c88a4e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b2c88a4e"]])

export default __exports__